import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormulaireServiceService } from '../../../services/formulaire-service.service';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { JsonContentEnum } from 'src/app/models/enums/json-content.enum';
import { TypeAnn } from '../../../common/models/type.ann';
import { LogService } from '../../../../shared/services/log.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { BehaviorSubject } from 'rxjs';
import { AnnonceurService } from '../../../common/services/annonceur/annonceur.service';
import { SimpIn } from '../../../../shared/models/component-messages/simp_in/simp_in';
import { ObjectToJsonStepperCreatorService } from '../../../../shared/services/object-to-json-stepper-creator.service';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { StepperBuilderService } from '../../../../avisDePub/creer/services/stepper.builder.service';

@Component({
	selector: 'app-formfnsimple',
	templateUrl: './formfns.component.html'
})
export class FormfnsComponent implements OnInit {
	private LOG: LogService = new LogService(FormfnsComponent);

	public ann = new TypeAnn();
	public createForm = false;

	@Input() form: FormGroup;
	@Input() indexPage;
	@Input() referenceAvis: string;
	@Input() currentJson: any = new BehaviorSubject(null);
	@Input() disabled = true;
	@Input() tableClass: string;
	@Input() formClass: string;
	@Input() formName: string;
	@Input() diffBoamp = false;
	@Input() diffJoue = false;

	public steps = [4, 5, 6, 7, 8, 9, 18, 19];
	public pages: number[];

	public simpIn = new SimpIn();

	public isFormValid = true;
	@Input() linkForRouter: string;

	constructor(private formulaireServiceService: FormulaireServiceService, private spinner: SpinnerVisibilityService, private annonceurService: AnnonceurService, public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private canNavigateInStepperService: CanNavigateInStepperService,
		private avisDataTransferService:AvisDataTransferService,
		private stepperBuilderService: StepperBuilderService
		) { }

	public ngOnInit() {
		this.pages = Array.from({ length: 6 }, (_, index) => index + 1);
		this.initForm();

	}

	private initForm() {
		this.spinner.show();
		this.currentJson.subscribe(data => {
			if (data != null && typeof data != 'string' && !this.createForm) {
				this.ann = data.jsonSaisieFormulaire.ann;
				if (data.jsonSaisieFormulaire.stepId && this.indexPage>0.4) {
					this.indexPage = data.jsonSaisieFormulaire.stepId;
				}
				this.canNavigateInStepperService.isBOAMPorJOUE = null;
				this.canNavigateInStepperService.isSHALorPS = null;
				this.annonceurService.annonceurBhs.next(data.jsonSaisieFormulaire.annonceur);
				this.createForm = true;
				this.avisDataTransferService.setFormData(data);
				this.stepperBuilderService.prepareMapErrors(data.jsonFieldsErrorsWarnings);
        		this.avisDataTransferService.jsonCSV = data.jsonCSV;
				this.avisDataTransferService.contenuPdf = data.jsonPdf;
				this.spinner.hide();
			} else {
				this.formulaireServiceService.getAvis(this.referenceAvis, FormsEnum.SIMP_IN, JsonContentEnum.EMPTY, data).subscribe(formData => {
					this.ann = formData.jsonSaisieFormulaire.ann;
					this.annonceurService.annonceurBhs.next(formData.jsonSaisieFormulaire.annonceur);
					this.createForm = true;
					const fluxAllerPA: any = formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos ? { ...formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos } : null;
					this.avisDataTransferService.sourceAppProfilAcheteurInfos = fluxAllerPA;
					this.avisDataTransferService.refConsultation=formData.refConsultation;
					this.avisDataTransferService.siret=formData.jsonSaisieFormulaire.ann.facturation.libelle.siret;
					this.avisDataTransferService.setFormData(formData);
					this.stepperBuilderService.initDefaultMapErrors('assets/data/errors/' + FormsEnum[FormsEnum.SIMP_IN] + '.json');
          			this.stepperBuilderService.initDefaultFormAD('assets/data/formAD/' + FormsEnum[FormsEnum.SIMP_IN] + '.json');
					this.stepperBuilderService.initDefaultFormPDF('assets/data/formPDF/' + FormsEnum[FormsEnum.SIMP_IN] + '.json');
					this.spinner.hide();
				});
			}
		});
	}

	getIsCheckValid(indexPage) {
		return this.stepperBuilderService.getIsCheckValidate('_STEP_ID_' + indexPage);
	}

	public getUid(indexPage) {
		return '_STEP_ID_' + indexPage + '_SepSep_Initial';
	}

	getUidCommon(indexPage) {
		return (
			'_STEP_ID_' + indexPage + '_SepSep_Annonce_index_1_SepSep_TypeAnn'
		);
	}

	getIntitule(indexPage) {
		return this.formulaireServiceService.hasTranslation(
			this.simpIn.step + indexPage
		)
			? this.simpIn.step + indexPage
			: this.simpIn.commonStep + indexPage;
	}

	getContents(indexPage) {
		switch (indexPage) {
			case this.steps[0]:
				return [];
			case this.steps[1]:
				return [];
			case this.steps[2]:
				return [];
			case this.steps[3]:
				return [];
			case this.steps[4]:
				return [];
			case this.steps[5]:
				return [];
			case this.steps[6]:
				return [];
			case this.steps[7]:
				return [];
		}
	}
}
